import React from "react";
import "./loading-reactor.css";

const LoadingReactor = () => (
    <div className="bb-loading-reactor" role="status" aria-label="Analyzing">
        <div className="bb-reactor">
            <div className="bb-reactor-ring"></div>
            <div className="bb-reactor-ring inner"></div>
            <div className="bb-reactor-core"></div>
        </div>

        <div className="bb-reactor-status" aria-hidden="true">
            Analyzing<span className="bb-reactor-dots"></span>
        </div>
    </div>
);

export default LoadingReactor;